<template>
  <VueEcharts :option="chartOptions" style="height: 420px" />
</template>

<script>
import {VueEcharts} from "vue3-echarts";
import {buildStatsChartOptions} from "@/utils/statsChart";

export default {
  name: "StatsTimeSeriesChart",
  components: {
    VueEcharts,
  },
  props: {
    buckets: {
      type: Array,
      default: () => [],
    },
    interval: {
      type: String,
      required: true,
    },
    seriesName: {
      type: String,
      required: true,
    },
    primaryColor: {
      type: String,
      default: '#1B6C97',
    },
    trendColor: {
      type: String,
      default: '#63A3C6',
    },
  },
  computed: {
    chartOptions() {
      return buildStatsChartOptions({
        buckets: this.buckets,
        interval: this.interval,
        seriesName: this.seriesName,
        primaryColor: this.primaryColor,
        trendColor: this.trendColor,
      })
    },
  },
}
</script>
